import { type FunctionComponent } from 'react';
import React from 'react';

import { formClasses } from '../../utils/BEM';
import { type FormErrorLike } from './FormErrors';

type FieldErrorMessageProps = {
    error?: FormErrorLike;
};
const FieldErrorMessage: FunctionComponent<FieldErrorMessageProps> = ({ error }) => {
    if (!error) {
        return null;
    }

    return <div {...formClasses('errors')}>{getErrorMessage(error)}</div>;
};

const getErrorMessage = (error: FormErrorLike): string => {
    if (error === false) {
        return '';
    }
    if (error === true) {
        return 'Please fill this field';
    }
    if (typeof error === 'string') {
        return error;
    }
    return error.text;
};

export default FieldErrorMessage;
